// extracted by mini-css-extract-plugin
export default {"fondoLogin":"ComprobarLigaCambioContrasenaComponent_fondoLogin__zLYY+"};